:host {
  display: flex;
  flex-direction: column;

  border: 1px solid var(--theme-secondary-border);
  border-radius: 4px;

  overflow: hidden;

  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
  background-color: var(--theme-primary-background);

  flex-shrink: 1;
  min-width: 0;

  padding: 16px 16px 10px 16px;

  /* Line between items only shows when multiple, and not for last item in a list */
  ::slotted(:only-child),
  ::slotted(:last-child) {
    border-bottom: none;
  }
}

/*
 This "wrapper" doesn't need to pad if its only showing a single item
 In this case the child elements will pad themselves
*/
:host(.single) {
  padding: 0px;
}

#header {
  color: var(--theme-primary-text);
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
  margin-bottom: 12px;
}
